import {
  BarSkeleton,
  CardSkeleton,
  SkeletonContainer,
} from './SkeletonCard.ui';

export const SkeletonCard = () => (
  <SkeletonContainer>
    <CardSkeleton />
    <BarSkeleton />
  </SkeletonContainer>
);
